import styled from 'styled-components';

export const PageContainer = styled.div``;
